// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-52ad97c1]{width:100%;border-top:1px solid #dfdfdf;border-left:1px solid #dfdfdf;margin:1em 0}table td[data-v-52ad97c1]{border-right:1px solid #dfdfdf;border-bottom:1px solid #dfdfdf;padding:1em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
